import { Product } from "../../../persistence/circular-dto/product.conflict";
import { ActionPointType } from "./_enum/action-point.enum";

export class ActionPointsDTO {
    public indication : IndicationActionPointDTO[];
    public fidelities : FidelityActionPointDTO[];
    public continuties : ContinutyActionPointDTO[];
    public sales : SaleActionPointDTO[];
    public advanceSales : AdvanceSaleGroup[]

    constructor(){
        this.indication = [];
        this.fidelities = [];
        this.continuties = [];
        this.sales = [];
        this.advanceSales = [];
    }

    public addActionPoint(actionPointType : ActionPointType, configuration : any)
        : ActionPointsDTO {
        switch(actionPointType) {
            case ActionPointType.Indication:
                this.indication.push(new IndicationActionPointDTO(configuration));
                break;
            case ActionPointType.Continuity:
                    this.continuties.push(new ContinutyActionPointDTO(configuration));
                break;
            case ActionPointType.Fidelity:
                this.fidelities.push(new FidelityActionPointDTO(configuration));
                break
            case ActionPointType.Sale:
                this.sales.push(new SaleActionPointDTO(configuration));
                break
            case ActionPointType.AdvanceSale:
                this.advanceSales.push(new AdvanceSaleGroup(configuration))
            default:
                break;
        }
        return this;
    }
}

export class BaseActionPointDTO {
    public id? : number;
    public applicableCampaignSequence : number;
    public endingCampaignSequence: number;
    public name : string;
    public points : number;
    public expirationPointsCampaignSequence : number;
    public reachId? : number;
    public campaignsToNet: number;
    public nameCampaigns?: string;
    public nameOfGrossCampaign?: string;
    public nameOfNetCampaign?: string;

    constructor(config : any){
        this.id = config.id;
        this.applicableCampaignSequence = config.campaignSequence;
        this.endingCampaignSequence = config.endingCampaignSequence != null ? config.endingCampaignSequence : config.campaignSequence;
        this.name = config.name;
        this.points = config.points;
        this.expirationPointsCampaignSequence = config.expirationPointsCampaign;
        this.reachId = config.reachId;
        this.campaignsToNet = config.campaignsToNet;
        this.nameCampaigns = config.nameCampaigns;
        this.nameOfGrossCampaign = config.nameOfGrossCampaigns;
        this.nameOfNetCampaign = config.nameOfNetCampaigns;
    }
}

export class IndicationActionPointDTO extends BaseActionPointDTO{
    public forReferrer: boolean;
    public minimumOrders?: number;
    public minimumOrdersForReferrer?: number;
    public minimumIndications?: number;

    constructor(config : any){
        super(config);
        this.forReferrer = config.forReferrer;
        this.minimumIndications = config.minimumIndications;
        this.minimumOrders = config.minimumOrders;
        this.minimumOrdersForReferrer = config.minimumOrdersForReferrer;
    }
}

export class ContinutyActionPointDTO extends BaseActionPointDTO {
    public consecutiveCampaigns : number;

    constructor(config : any){
        super(config);
        this.consecutiveCampaigns = config.consecutiveCampaigns;
    }
}

export class FidelityActionPointDTO extends BaseActionPointDTO {
    public periodRequirement: PeriodRequirement[];

    constructor(config : any){
        super(config);
        this.periodRequirement = config.periodRequirement;
    }
}

export class PeriodRequirement{
    public sequenceFrom: number;
    public sequenceTo: number;
    public minimum: number;

    constructor(sequenceFrom: number, sequenceTo: number, minimum: number) {
        this.sequenceFrom = sequenceFrom;
        this.sequenceTo = sequenceTo;
        this.minimum = minimum;
    }
}

export class SaleActionPointDTO extends BaseActionPointDTO {
    public fromSaleValue : number;
    public toSaleValue : number;
    public advanceSaleProductGroups : AdvanceSaleGroup[];
    public multiplication : number;

    constructor(config : any){
        super(config);
        this.fromSaleValue = config.toSaleValueMin;
        this.toSaleValue = config.toSaleValueMax;
        this.multiplication = config.multiplication;
        this.advanceSaleProductGroups = config.advanceSaleProductsGroups;
    }
}

export class CampaignProductExtraPoints extends BaseActionPointDTO {
    public campaignProductId : number;
    public extraPoints : number;
}

export class AdvancedSaleProductsDTO {
    public advanceSaleProducts: CampaignProductPoints[];
}

export class CampaignProductPoints  {
    public campaignProductId : number;
    public points : number;

    constructor(campaignProductId: number, points: number) {
        this.campaignProductId = campaignProductId;
        this.points = points;
    }
}

export class AdvanceSaleCampaignProducts{
    public product: Product;
    public points: number;

    constructor(product: Product, points: number) {
        this.product = product;
        this.points = points;
    }
}

export class AdvanceSaleSelectedCampaignProducts{
    public campaignId: number;
    public campaignSequence: number;
    public campaignName: string;
    public advanceSaleProducts: AdvanceSaleGroupProduct[];
}

export class AdvanceSaleGroupProduct
{
    public product: Product;
    public minimum: number;
    public campaignSequence: number;
    public campaignProductId: number;
    public advanceSaleRequiredProductGroupId: number;

    constructor(minimum: number, campaignProductId: number, campaignSequence?: number, product?: Product, advanceSaleRequiredProductGroupId?: number) {
        this.product = product;
        this.minimum = minimum;
        this.campaignProductId = campaignProductId;
        this.campaignSequence = campaignSequence;
        this.advanceSaleRequiredProductGroupId = advanceSaleRequiredProductGroupId;
    }
}

export class AdvanceSaleGroup extends BaseActionPointDTO {
    public advanceSaleProducts: AdvanceSaleGroupProduct[];
    public advanceSaleCampaignProducts: AdvanceSaleSelectedCampaignProducts[];
    public advanceSaleRequiredProductGroups: AdvanceSaleRequiredProductGroup[];
    public extraPoints: ExtraPoints[];
    public advanceSaleLevels: AdvanceSaleLevel[];
    public minimumCampaignProducts: number;
    public maximumCampaignProducts: number;
    public minimumValue: number;
    public maximumValue: number;

    constructor(config: any) {
        super(config);
        this.minimumCampaignProducts = config.minimumCampaignProducts;
        this.maximumCampaignProducts = config.maximumCampaignProducts;
        this.minimumValue = config.minimumValue;
        this.maximumValue = config.maximumValue;
        this.advanceSaleProducts = config.advanceSaleProducts;
        this.advanceSaleCampaignProducts = config.advanceSaleCampaignProducts;
        this.advanceSaleRequiredProductGroups = config.advanceSaleRequiredProductGroups;
        this.advanceSaleLevels = config.advanceSaleLevels;
    }
}

export class AdvanceSaleRequiredProductGroup {
    public id: number;
    public advanceSaleId: number;
    public quantity: number;
    public name: string;
    public advanceSaleRequiredProducts: AdvanceSaleGroupProduct[];

    constructor(advanceSaleId: number, quantity: number, name: string, products: AdvanceSaleGroupProduct[], id?: number) {
        this.id = id;
        this.advanceSaleId = advanceSaleId;
        this.quantity = quantity;
        this.name = name;
        this.advanceSaleRequiredProducts = products;
    }
}

export class AdvanceSaleLevel {
    public id: number;
    public level: number;
    public points: number;
    public minProducts: number;
    public maxProducts: number;

    constructor(level: number, points: number, minProducts: number, maxProducts: number) {
        this.level = level;
        this.points = points;
        this.minProducts = minProducts;
        this.maxProducts = maxProducts;
    }
}

export class ExtraPoints {
    public id: number;
    public advanceSaleConfiguration: number | null;
    public points: number;
    public name: string;
    public extraPointsProducts: ExtraPointsProducts[];
}

export class ExtraPointsProducts {
    public id: number;
    public requiredQuantity: number;
    public productCode: string;
    public groupNumber: number | null;
}



